module.exports = __webpack_public_path__ + "static/travelife-75c20fbc2ec7b472a1380e5f87e4fa63.svg";